import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { AlertSpan } from "../common/CommonStyled";

const Container = styled.input<{ $isValid?: boolean, $disabled? :boolean }>`
  border-radius : 5px;
  border: 1px solid 
  ${({ $isValid, $disabled }) =>
      $disabled
        ? "#DDDDDD" // ✅ disabled일 때 border
        : $isValid === undefined || $isValid === null
        ? "#ccc"
        : $isValid
        ? "#ccc"
        : "#FF5A5A"};
  font-size: 16px;
  width: 100%;
  display: block;
  flex-grow: 1;
  padding: 10px 20px;
  box-sizing: border-box;
  background-color: ${({ $disabled })=> $disabled ? '#F5F5F5': 'white'};
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
`

interface Props {
  type? :string;
  defaultValue?: string; 
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isValid? : boolean;
  pattern? : string;
  title? : string;
  value? : string;
  disabled? : boolean;
  setCond? : React.Dispatch<boolean>
}

const InputBoxOnChangePWCheck = ({ placeholder, defaultValue, type, onChange , isValid, pattern, title, value, disabled, setCond }: Props) => {
  const [result,setResult]= useState('')
  const [isRegex,setIsRegex] = useState(true)

  const handleChange = (e:React.ChangeEvent<HTMLInputElement>)=>{
    const Changevalue = e.target.value
    setResult(Changevalue)

    if(Changevalue.length !==0){
      if(Changevalue !== value){
        setIsRegex(false)
      }
      else{
        setIsRegex(true)
      }
    }
  }
  useEffect(()=>{
    setCond?.(isRegex)
  },[isRegex])


  return (
    <Wrapper>
    <Container
      type={type}
      placeholder={placeholder}
      defaultValue={defaultValue}
      onChange={(e)=>handleChange(e)}
      pattern={pattern}
      title={title}
      $isValid={isValid}
      value={result}
      $disabled={disabled}
      disabled={disabled}
    />
    {!isRegex ? 
    <AlertSpan $isValid={false}>비밀번호가 일치하지 않습니다.</AlertSpan>:<></>}
    </Wrapper>
  );
};

export default InputBoxOnChangePWCheck;
